<template>
	<div class='bedoInputTree' @click.stop=''>
		<!-- <Tree :data="schoolData" ref='schoolTree' @on-check-change='getSchoolTree'    expand-node :show-checkbox='ischeck' ></Tree> -->
		<Input v-model="inputtext" placeholder="" readonly @on-focus='showTree' />
		<div v-if='ischeck' class='inputtreeContent' :class='[showtreeClass?"active":""]'>
			<Tree :data="schoolData" ref='schoolTree' @on-toggle-expand='getData' @on-check-change='getSchoolTree'
				multiple show-checkbox expand-node></Tree>
		</div>
		<div v-else class='inputtreeContent' :class='[showtreeClass?"active":""]'>
			<Tree :data="schoolData" ref='schoolTree' @on-toggle-expand='getData' @on-select-change='getSchoolTree'
				@getCheckedAndIndeterminateNodes></Tree>
		</div>

		<!-- @on-check-change='getSchoolTree' -->
	</div>
</template>

<script>
	import uitls from '../utils/getSchoolData'
	export default {
		name: 'schoolTree',
		data() {
			return {
				schoolData: [],
				initSchoolData: [],
				checkPid: [],
				inputtext: '',
				curSchoolName: '',
				showtreeClass: false,

			}
		},
		watch: {
			treekey(newval, oldval) {
				//console.log(newval,oldval)
				this.schoolData = []
				this.schoolData = JSON.parse(JSON.stringify(this.initSchoolData))
				this.checkPid = []
				this.showtreeClass = false
				this.inputtext = ''
				this.filterDeviceTree(this.schoolData, this.treedata, this.ischeck);
			},
			hideInputNum(newval, oldval) {
				this.showtreeClass = false
			},
		},
		props: {
			treedata: {
				type: Array,
				default: function() {
					return []
				},
			},
			treekey: {
				type: Number,
			},
			hideInputNum: {
				type: Number,
			},
			ischeck: {
				type: Boolean,
				default: function() {
					return true
				},
			},
		},
		mounted() {
			var that = this
			// var userInfo = JSON.parse(localStorage.getItem('inchUserinfo'))
			//    var schoolid  = localStorage.getItem('curSchoolid')
			// this.curSchoolid = userInfo.schoolid

			uitls.getSchoolData().then(res => {
				uitls.getSchoolData('video').then(back => {
          uitls.getSchoolData('audio').then(aud => {
            var backData = back.concat(aud)
            that.schoolData = res.concat(backData)
         
            that.initSchoolData = JSON.parse(JSON.stringify(that.schoolData))
          })
				})

			})



      // uitls.getSchoolData('all').then(res => {
				
         
      //       that.schoolData = res
          
      //       that.initSchoolData = JSON.parse(JSON.stringify(that.schoolData))
				

			// })

			//   var schoolTreeData = localStorage.getItem('schoolTree')
			//   var _data = JSON.parse(schoolTreeData)
			// _data.map(function(val, index) {
			// 	val['expand'] = true
			// })
			//     that.schoolData = _data
			//     that.initSchoolData = JSON.parse(JSON.stringify(_data))


		},
		methods: {
			renderNewData(a, ids) {
				var that = this
				//console.log(ids,'ids----->')
				if (a && a['children'] && a['children'].length > 0) {
					var b = a['children']
					b.map(function(val, index) {
						if (val['children'].length > 0) {

							ids.push(val['guid'])

							that.renderNewData(val['children'], ids)
						} else {

							return ids.push(a['guid'])
						}
					})

				} else {


					return ids.push(a['guid'])
				}

			},
			showTree() {

				this.showtreeClass = true
			},
			getSchoolTree(val) {
				//console.log(val,'val====')
				if (this.ischeck) {
					this.getCheckData(this.$refs.schoolTree.getCheckedAndIndeterminateNodes())

				} else {
					this.getSelectData(this.$refs.schoolTree.getSelectedNodes())

				}

			},
			getSelectData(res) {

				var data = this.schoolData
				var school = []
				var grades = []
				var that = this
				school = data.filter(function(val, index) {
					return val['pid'] == 0
				})

				this.curSchoolName = school[0]['name']
				grades = school[0]['children'].filter(function(val, index) {
					return val['pid'] == that.curSchoolid
				})

				var siglegrade = grades.filter(function(val, index) {
					return val['id'] == res[0]['pid']
				})

				var classid = this.curSchoolid + ',' + siglegrade[0]['id'] + ',' + res[0]['id']
				var classname = this.curSchoolName + ',' + siglegrade[0]['name'] + ',' + res[0]['name']

				var classObj = {
					classid: classid,
					classname: classname,
					onlyClassid: classid
				}
				this.inputtext = classname
				this.showtreeClass = false
				this.$emit('changeClass', classObj)
			},
			getCheckData(newData) {
				//console.log(newData,'data')
				var data = newData
				// var data = newData.filter(function(val,index){
				//   return val['children'].length == 0
				// })
				//console.log(data,'过滤后data')
				if (data.length == 0) {
					var classObj = {
						classid: '',
						classname: '',
						onlyClassid: '',
					}
					this.inputtext = ''

					this.$emit('changeClass', classObj)

				}

				var that = this
				var arr = [],
					arrname = [];
				data.map(function(val, index) {

					// if(val['selfid']!=''){
					//     arr.push(val['selfid']+'_'+val['guid'])
					// }else{
					arr.push(val['guid'])
					// }

					arrname.push(val['name'])
				})
				this.inputtext = arrname.join(',')

				var classObj = {
					classid: arr.join(','),
					classname: arrname.join(','),
					onlyClassid: arr.join(',')
				}


				this.$emit('changeClass', classObj)
				// school = data.filter(function(val,index){
				// 	return val['pid'] == 0
				// })
				// this.curSchoolName = school[0]['name']
				// grades = data.filter(function(val,index){
				// 	return val['pid'] == that.curSchoolid
				//	})
				// this.formateData(data)

			},
			formateData(a, b) {
				var that = this
				var classid = ''
				var classname = ''
				var onlyClassid = ''

				var str = []
				a.map(function(val, index) {
					var curStr = []
					//console.log(val,'val')
				})




				return false;
				for (var i = 0; i < a.length; i++) {
					classid += a[i]['id'] + ','
					classname += a[i]['name'] + ','
					for (var j = 0; j < a[i]['children'].length; j++) {
						if (a[i]['children'][j]['checked']) {
							classid += a[i]['children'][j]['id'] + ','
							classname += a[i]['children'][j]['name'] + ','
							onlyClassid += a[i]['children'][j]['id'] + ','
						}
					}
				}
				classid = classid.substring(0, classid.length - 1)
				classname = classname.substring(0, classname.length - 1)
				onlyClassid = onlyClassid.substring(0, onlyClassid.length - 1)
				var classObj = {
					classid: classid,
					classname: classname,
					onlyClassid: onlyClassid
				}
				this.inputtext = classname

				this.$emit('changeClass', classObj)

			},
			getCheckId(a, b) {
				//console.log(a,'aaaaaaaaa')
				var that = this
				if (a && a['children'].length > 0) {
					b.push(a['guid'])
					that.getCheckId(a['children'], b)
				} else {
					if (a['checked']) {
						b.push(a['guid'])

						return b
					} else {
						return b
					}
				}
			},
			formateData2(a, b) {
				var classid = this.curSchoolid + ','
				var classname = this.curSchoolName + ','
				var onlyClassid = ''
				for (var i = 0; i < a.length; i++) {
					classid += a[i]['id'] + ','
					classname += a[i]['name'] + ','
					for (var j = 0; j < a[i]['children'].length; j++) {
						if (a[i]['children'][j]['checked']) {
							classid += a[i]['children'][j]['id'] + ','
							classname += a[i]['children'][j]['name'] + ','
							onlyClassid += a[i]['children'][j]['id'] + ','
						}
					}
				}
				classid = classid.substring(0, classid.length - 1)
				classname = classname.substring(0, classname.length - 1)
				onlyClassid = onlyClassid.substring(0, onlyClassid.length - 1)
				var classObj = {
					classid: classid,
					classname: classname,
					onlyClassid: onlyClassid
				}
				this.inputtext = classname

				this.$emit('changeClass', classObj)

			},
			filterDeviceTree(tree, ids, ischeck) {

				var that = this;
				for (var i = 0; i < tree.length; i++) {
					for (var j = 0; j < ids.length; j++) {
						if (tree[i]['guid'] == ids[j]) {
							this.checkPid.push(tree[i]['pid'])
							this.inputtext += tree[i]['name'] + ','
							if (ischeck && tree[i]['children'].length == 0) {
								// tree[i]['checked'] = true
								that.$set(tree[i], "checked", true);
							} else {
								that.$set(tree[i], "selected", true);
								// tree[i]['selected'] = true
							}

							tree[i]['expand'] = true
						}
					}
					if (tree[i]['children'].length > 0) {
						this.filterDeviceTree(tree[i]['children'], ids, ischeck)
					}
				}

				this.schoolData = tree

				//this.getParId(tree,that.checkPid)
			},
			getParId(tree, ids) {
				var that = this;
				for (var i = 0; i < tree.length; i++) {
					for (var j = 0; j < ids.length; j++) {
						if (tree[i]['id'] == ids[j]) {
							tree[i]['expand'] = true

						}
					}
					if (tree[i]['children'].length > 0) {
						this.getParId(tree[i]['children'], ids)
					}
				}

				that.schoolData = tree
			},
			getData(a, b, c) {

			}


		}
	}
</script>

<style>
	.bedoInputTree {
		position: relative;
	}

	.inputtreeContent {

		background: #fff;
		position: absolute;
		top: 33px;
		left: 0px;
		display: none;
		z-index: 10000;
		height: 300px;
		overflow-y: scroll;
		padding: 0px 20px 20px 10px;
		border: 1px solid #f5f5f5;
		border-top: 0 none;
	}

	.inputtreeContent.active {
		display: block;
	}
</style>
